// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.file-card:nth-child(odd) {
  background-color: whitesmoke;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
